import { Trans, t } from "@web-monorepo/i18n/macro";
import { DDSBodyText, DDSLabelText } from "@web-monorepo/dds";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import ShadowCard from "src/shared/components/ShadowCard";
import styles from "./ConundrumCard.module.css";

type ConundrumCardProps = {
  mojo: string;
  href: string;
  title: string;
  description: ReactNode;
  duration: string;
};

export default function ConundrumCard({ href, mojo, title, description, duration }: ConundrumCardProps) {
  return (
    <ShadowCard className={styles.card}>
      <Link to={href} className={styles.link}>
        <div className={styles.linkInner}>
          <div className={styles.leftColumn}>
            <DDSLabelText as="h2" className={styles.title}>
              {title}
            </DDSLabelText>
            <DDSBodyText level="md" variant="secondary">
              {description}
            </DDSBodyText>
            <DDSBodyText level="md" variant="secondary" className={styles.duration}>
              <Trans>{{ duration }} min activity</Trans>
            </DDSBodyText>
            <div className={styles.emoji}>{"🌠 ⚖️ 💭"}</div>
          </div>
          <div className={styles.imageColumn}>
            <img src={mojo} className={styles.image} alt={t`Conundrum`} />
          </div>
        </div>
      </Link>
    </ShadowCard>
  );
}
